import forEach from 'lodash/forEach'
import { MutableRefObject, useCallback } from 'react'

export const useHorizontalCarouselButton = (ref: MutableRefObject<HTMLDivElement | null>, buttonMoveOneField, gap) => {
  const getScrollMovement = useCallback((move: (firstVisibleLeftIndex: number, numberOfElementsInView: number) => number) => {
    if (ref.current) {
      const sliderWidth = ref.current!.clientWidth
      const scrollPosition = ref.current?.scrollLeft
      const childWidth = (ref.current?.firstElementChild?.clientWidth || 0) + gap
      const firstVisibleLeftIndex = Math.floor(scrollPosition / childWidth)
      const numberOfElementsInView = Math.floor(sliderWidth / childWidth)
      if (buttonMoveOneField) {
        return move((firstVisibleLeftIndex * childWidth), childWidth)
      }
      return move(firstVisibleLeftIndex, numberOfElementsInView) * childWidth
    }
    return 0
  }, [buttonMoveOneField, gap, ref])

  const getScrollMovementLeftForUneven = (children) => {
    if (!ref.current) {
      return 0
    }
    const clientWidth = ref.current!.clientWidth || 0
    const scrollLeft = ref.current!.scrollLeft || 0
    let childCounter = ref.current!.scrollWidth || 0
    let move = 0
    forEach(children, (child: HTMLElement) => {
      if (child.clientWidth) {
        childCounter -= child.clientWidth + gap
        if (childCounter <= scrollLeft - gap && childCounter >= scrollLeft - (clientWidth + gap + gap)) {
          move = childCounter
          if (buttonMoveOneField) {
            return
          }
        }
      }
    })
    return move
  }
  const getScrollMovementRightForUneven = (children) => {
    if (!ref.current) {
      return 0
    }
    const clientWidth = ref.current?.clientWidth || 0
    const scrollLeft = ref.current?.scrollLeft || 0
    let childCounter = 0
    let move = 0
    forEach(children, (child: HTMLElement) => {
      if (child.clientWidth) {
        childCounter += child.clientWidth + gap
        if (childCounter >= scrollLeft && childCounter <= scrollLeft + clientWidth + gap + gap) {
          move = childCounter
          if (buttonMoveOneField) {
            return
          }
        }
      }
    })
    return move
  }
  return { getScrollMovement, getScrollMovementRightForUneven, getScrollMovementLeftForUneven }
}
